import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { UserRole } from "@/lib/schema";
import { useLocation } from "wouter";
import { LoadingScreen } from "@/components/ui/LoadingScreen"; 

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
  fallback?: React.ReactNode;
}

export function ProtectedRoute({ children, allowedRoles, fallback }: ProtectedRouteProps) {
  const { currentUser, userData, loading } = useAuth();
  const [_, setLocation] = useLocation();

  // Handle navigation when user is not authenticated
  useEffect(() => {
    if (!loading && (!currentUser || !userData)) {
      setLocation("/");
    }
  }, [loading, currentUser, userData, setLocation]);

  if (loading) {
    return <LoadingScreen text="Loading..." />;
  }

  if (!currentUser || !userData) {
    return null;
  }

  if (allowedRoles && !allowedRoles.includes(userData.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Access Denied</h1>
          <p className="text-slate-600">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
